core.directive('edmPolandMap', ['$http',
    function($http) {
        var definition = {
            restrict: 'E',
            replace: true,
            scope: {
                data: '=',
                title: '@',
                seriesName: '@',
                type: '@'
            },
            templateUrl: 'core/application/directive/edmPolandMap/template/edm-poland-map.html',
            link: function (scope, element, attr) {
                var url = '/resource/asset/pl-all.geo.json';
                var joinBy = 'hasc';
                if(scope.type === 'europe') {
                    url = '/resource/asset/europe.geo.json';
                    joinBy = 'hc-key'
                }
                $http.get(url).then(function (mapData) {
                    element.highcharts('Map', {

                        title : {
                            text : scope.title
                        },

                        mapNavigation: {
                            enabled: true,
                            buttonOptions: {
                                verticalAlign: 'bottom'
                            }
                        },

                        colorAxis: {
                        },

                        series : [{
                            data : scope.data,
                            mapData: mapData.data,
                            joinBy: [joinBy, 'code'],
                            name: scope.seriesName,
                            states: {
                                hover: {
                                    color: '#BADA55'
                                }
                            },
                            dataLabels: {
                                enabled: true,
                                format: '{point.name}'
                            }
                        }],
                        chart: {
                            borderWidth: 0,
                            width: 550,
                            height: 550,
                            shadow: false,
                            backgroundColor: 'transparent'
                        }
                    });
                });


            }
        };

        return definition;
    }
]);